/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import {
  Modal, Card, Col, Row,
} from 'antd'

import imageBedAndLiving from '../../../resource/image/BedAndLiving.jpg'
import imageKitchen from '../../../resource/image/Kitchen.jpg'

const { Meta } = Card

const ParametricTypeModal = ({
  visible,
  onSuccess,
  onCancel,
}) => {
  useEffect(() => {
  }, [])

  return (
    <Modal
      title="Select Parametric Type"
      visible={visible}
      maskClosable={false}
      onCancel={() => { onCancel() }}
      okButtonProps={{ style: { display: 'none' } }}
      cancelButtonProps={{ style: { display: 'none' } }}
    >
      <Row gutter={{ sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <Card
            hoverable
            cover={<img alt="BedAndLiving" src={imageBedAndLiving} />}
            onClick={() => onSuccess('BLV')}
          >
            <Meta title="Bed & Living" />
          </Card>
        </Col>
        <Col span={12} style={{ alignItems: 'center' }}>
          <Card
            hoverable
            cover={<img alt="Kitchen" src={imageKitchen} />}
            onClick={() => onSuccess('KIT')}
          >
            <Meta title="Kitchen" />
          </Card>
        </Col>
      </Row>
    </Modal>

  )
}

export default ParametricTypeModal

